"use strict";
// @ts-ignore
try {
    self['workbox:routing:6.2.4'] && _();
}
catch (e) { }
